import { useQuery } from "@tanstack/react-query";
import { getTargetareListaVersiune } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareListaVersiune(id: number | null) {
  return useQuery({
    queryKey: queryKeys.targetare.listaVersiune(id ?? 0),
    queryFn: () => getTargetareListaVersiune(id ?? 0),
    select: (response) => response.data,
    enabled: id !== null,
    staleTime: 1000 * 60 * 10,
    retry: 1,
  });
}
